import { type FlowStagesRequest, flowStagesResponseSchema } from "../../types/flow-stages.types"
import { BaseApiService, KyOptions } from "./api.service"

class FlowStagesServiceRaw extends BaseApiService {
  getCurrentStage = (flowKey: string, config: KyOptions = {}) => {
    return this.instance
      .get(`/flow-stages/${flowKey}`, config)
      .then(this.getData)
      .then((data) => {
        return this.parse(data, flowStagesResponseSchema)
      })
  }

  updateStage = (flowKey: string, data: FlowStagesRequest, config: KyOptions = {}) => {
    return this.instance
      .post(`/flow-stages/${flowKey}`, data, config)
      .then(this.getData)
      .then((data) => this.parse(data, flowStagesResponseSchema))
  }
}

/** Exporting a singleton object to entire app */
export const FlowStagesService = new FlowStagesServiceRaw()
